import { useEffect } from 'react'

import { HoveredPointData, usePointHover } from './usePointHover'

interface PointHoverProps {
  onHover?: (hoverData: HoveredPointData | null) => void
  enabled: boolean
}

/**
 * Component that only handles hover detection for tooltips
 * It doesn't return anything and doesn't do anything visual
 */
export function PointHover({ onHover, enabled }: PointHoverProps) {
  const { hoveredPoint } = usePointHover(enabled, 100)

  useEffect(() => {
    if (onHover) {
      onHover(hoveredPoint)
    }
  }, [hoveredPoint, onHover])

  return null
}
